/**
 * Integrations Dashboard Utils
 */
function normalizeStatus(status: string): string {
  const map: Record<string, string> = {
    CONNECTED: 'Connected',
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    DISCONNECTED: 'Disconnected',
    ONBOARDED: 'Onboarded',
    DISCOVERED: 'Discovered',
  };

  return map[status.toUpperCase()] || status;
}

export default normalizeStatus;
